import { getAgeKeyFromCookie } from '../util/cookies';
import SiteEvents from '../util/site-events';

class BlockTimelineContent {
	constructor($block) {
		this.$block = $block;
		this.blockEl = this.$block.get(0);

		const ageKey = getAgeKeyFromCookie();

		this.displayImageForAge(ageKey, 'image');
		this.displayImageForAge(ageKey, 'video');
		this.displayPhotoGridForAge(ageKey);

		SiteEvents.imageBuddyUpdate();
	}

	displayImageForAge(ageKey, type = 'image') {
		const imageEls = Array.from(
			this.blockEl.querySelectorAll(`.timeline-block-content__image--${type}[data-age]`)
		);

		if (!imageEls.length) {
			return;
		}

		const ageImageEl = this.blockEl.querySelector(
			`.timeline-block-content__image--${type}[data-age="${ageKey}"]`
		);

		if (ageImageEl) {
			// age specific image has been found
			ageImageEl.classList.remove('hide');
		} else {
			// no age specific image was found; un-hide the default row
			const defaultImageEl = this.blockEl.querySelector(
				`.timeline-block-content__image--${type}[data-age="default"]`
			);

			if (defaultImageEl) {
				defaultImageEl.classList.remove('hide');
			}
		}
	}

	displayPhotoGridForAge(ageKey) {
		const gridRowEls = Array.from(
			this.blockEl.querySelectorAll('.timeline-block-content__image-grid .row[data-age]')
		);

		if (!gridRowEls.length) {
			return;
		}

		const ageGridRowEl = this.blockEl.querySelector(
			`.timeline-block-content__image-grid .row[data-age="${ageKey}"]`
		);

		if (ageGridRowEl) {
			// age specific row has been found
			ageGridRowEl.classList.remove('hide');
		} else {
			// no age specific row was found; un-hide the default row
			const defaultGridRowEl = this.blockEl.querySelector(
				'.timeline-block-content__image-grid .row[data-age="default"]'
			);

			if (defaultGridRowEl) {
				defaultGridRowEl.classList.remove('hide');
			}
		}
	}
}

export default BlockTimelineContent;
